export default __webpack_public_path__ + "media/review-save3x.c67c9dc5.png";